import styled from 'styled-components'

export const LoginWrapper = styled.div`
  @media only screen and (max-width: 1023px) {
    height: calc(95vh - var(--headerLHeight));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const LoginContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 102.2px);

  & > span {
    &:nth-child(1),
    &:nth-child(2) {
      position: absolute !important;
      width: 10% !important;
    }

    &:nth-child(1) {
      bottom: 10%;
      right: 0;
    }

    &:nth-child(2) {
      top: 10vh;
      left: 45%;
    }
  }

  #spacer,
  #formbox-container {
    width: 50%;
  }

  @media only screen and (max-width: 1023px) {
    min-height: 0;

    #spacer {
      display: none;
    }

    #formbox-container {
      width: 100%;
      z-index: 2;
    }

    #rect1,
    #rect2 {
      display: none;
    }
  }
`

export const BoxesContainer = styled.div`
  #rect3,
  #rect4 {
    display: none;
  }

  @media only screen and (max-width: 1023px) {
    display: flex;
    justify-content: space-between;
    width: 80%;

    #rect3,
    #rect4 {
      display: inline;
    }
  }
`
